import React, { useEffect, useState } from 'react'

import DoneOutlineSharpIcon from '@mui/icons-material/DoneOutlineSharp'
import Box from '@mui/material/Box'
import DialogContent from '@mui/material/DialogContent'
import Avatar from '@mui/material/Avatar'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid2'
import { useSnackbar } from '../../alert/SnackbarProvider'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { formatDateToDDMMYYYY } from '../../api/formatDate'
import '../../styles/main.css'
import {
  updateData,
  addRequestsData,
  deleteData,
  getData,
  upsertDataTournaments,
} from '../../api/indexedDBHandler'
import { useParams } from 'react-router-dom'
import Backdrop from '@mui/material/Backdrop'
import DeleteIcon from '@mui/icons-material/Delete'
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency'

import Button from '@mui/material/Button'

import IconButton from '@mui/material/IconButton'
import SmartToyIcon from '@mui/icons-material/SmartToy'
import Modal from '@mui/material/Modal'
import EditSharpIcon from '@mui/icons-material/EditSharp'
import CircularProgress from '@mui/material/CircularProgress'
import StarIcon from '@mui/icons-material/Star'
import ModalAddTeam from '../Modal/ModalAddTeam'

const TeamRegistrationCard = ({
  tournament,
  teamDataTemp,
  athleteDataTemp,
  teamIsLocation,
  teamNotLocation,
}) => {
  const { id } = useParams()
  const [openBackdrop, setOpenBackdrop] = useState(false)
  const [open, setOpen] = useState(false)
  const [openModal, setOpenModal] = React.useState(false)
  const handleOpenModal = () => setOpenModal(true)
  const handleCloseModal = () => setOpenModal(false)

  const [openModalSportsmen, setOpenModalopenModalSportsmen] =
    React.useState(false)
  const handleCloseModalSportsmen = () => setOpenModalopenModalSportsmen(false)

  const [modalAvatar, setModalAvatar] = useState('')
  const [modalName, setModalName] = useState('')
  const [modalIdentification, setModalIdentification] = useState('')
  const [modalId, setModalId] = useState('')
  const [modalDob, setModalDob] = useState('')
  const [modalPhone, setModalPhone] = useState('')
  const [modalSports_category, setModalSports_category] = useState('')
  const [modalInsurance, setModalInsurance] = useState('')
  const [modalMedical, setModalMedical] = useState('')
  const [modalRusad, setModalRusad] = useState('')

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editData, setEditData] = useState(null)
  const [teamData, setteamData] = useState(null)
  const [athleteData, setathleteData] = useState(null)
  // const [isVisable, setIsVisable] = useState(true)
  const [backgroundColor, setbackgroundColor] = useState('white')
  useEffect(() => {
    if (teamDataTemp?.status_location === 1) setbackgroundColor('#BADBAD33')
    else if (teamDataTemp?.status_location === 2)
      setbackgroundColor('#EBC2AF33')

    // if (teamDataTemp?.status_location) setIsVisable(false)
    setteamData(teamDataTemp)
  }, [teamDataTemp])

  useEffect(() => {
    setathleteData(athleteDataTemp)
  }, [athleteDataTemp])

  useEffect(() => {
    if (athleteData)
      setEditData({
        teamName: name(),
        spName1: athleteData[0]?.fio ? athleteData[0].fio.trim() : '',
        spid1: athleteData[0]?.id ? athleteData[0].id : null,
        category1: athleteData[0]?.sports_category
          ? athleteData[0].sports_category.trim()
          : '',
        date1:
          athleteData[0]?.dob && athleteData[0]?.dob != '0000-00-00'
            ? athleteData[0].dob.trim()
            : '',
        spName2: athleteData[1]?.fio ? athleteData[1].fio.trim() : '',
        spid2: athleteData[1]?.id ? athleteData[1].id : null,
        category2: athleteData[1]?.sports_category
          ? athleteData[1].sports_category.trim()
          : '',
        date2:
          athleteData[1]?.dob && athleteData[1]?.dob != '0000-00-00'
            ? athleteData[1].dob.trim()
            : '',
        spName3: athleteData[2]?.fio ? athleteData[2].fio.trim() : '',
        spid3: athleteData[2]?.id ? athleteData[2].id : null,
        category3: athleteData[2]?.sports_category
          ? athleteData[2].sports_category.trim()
          : '',
        date3:
          athleteData[3]?.dob && athleteData[3]?.dob != '0000-00-00'
            ? athleteData[3].dob.trim()
            : '',
      })
  }, [athleteData])

  const showSnackbar = useSnackbar()

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }))

  const name = () => {
    if (tournament.competition_type == 'Рейтинговое соревнование')
      return teamData?.team_name_ru
    return teamData?.preferred_name == 'en'
      ? teamData?.team_name_en
        ? teamData?.team_name_en
        : teamData?.team_name_ru
      : teamData?.team_name_ru
  }
  const openCupBut = () => {
    // if (isAccess) navigate('/tournaments/' + id + '/' + path) && teams
  }

  const handleOpanSp = (e) => {
    setModalName(e.fio)

    setModalIdentification('аккаунт: ' + e.identification)
    const idsp = e.id == 72 ? '072' : e.id == 7 ? '007' : e.id
    setModalId('ID в системе ПротоКарп: ' + idsp)
    setModalPhone('Телефон: ' + e.phone)
    setModalDob(
      e.dob !== '0000-00-00'
        ? 'Дата рождения: ' + formatDateToDDMMYYYY(e.dob)
        : 'Дата рождения: нет данных'
    )
    const insurance = e.insurance
      ? 'Спортивная страховка: ' + e.insurance
      : 'Спортивная страховка: нет данных'
    const insurance_expiry = e.insurance_expiry
      ? ', до ' + formatDateToDDMMYYYY(e.insurance_expiry)
      : ''
    setModalInsurance(insurance + insurance_expiry)

    const medical_clearance_expiry = e.medical_clearance_expiry
      ? 'Допуск врача: до ' + formatDateToDDMMYYYY(e.medical_clearance_expiry)
      : 'Допуск врача: нет данных'

    setModalMedical(medical_clearance_expiry)

    const rusad_certificate = e.rusad_certificate
      ? 'Сертификат РУСАД: ' + e.rusad_certificate
      : 'Сертификат РУСАД: нет данных'

    const rusad_expiry = e.rusad_expiry
      ? ', от ' + formatDateToDDMMYYYY(e.rusad_expiry)
      : ''
    setModalRusad(rusad_certificate + rusad_expiry)
    const sports_category = e.sports_category ? e.sports_category : ''
    const sports_category_order_date = e.sports_category_order_date
      ? e.sports_category_order_date !== '0000-00-00'
        ? ' от ' + formatDateToDDMMYYYY(e.sports_category_order_date)
        : ''
      : ''
    const sports_category_order_number = e.sports_category_order_number
      ? ' №' + e.sports_category_order_number
      : ''
    const sp_cat =
      sports_category +
      sports_category_order_number +
      sports_category_order_date

    setModalSports_category(
      sp_cat ? 'Спортивный разряд: ' + sp_cat : 'Спортивный разряд: нет данных'
    )
    setModalAvatar(e.avatar)
    setOpenModalopenModalSportsmen(true)
  }
  const dob_sport_categori = (sports_category, dob) => {
    var arr = []
    if (sports_category) arr.push(sports_category)
    if (dob != '0000-00-00') arr.push(formatDateToDDMMYYYY(dob) + ' г.р.')
    return arr.join(', ')
  }

  const trueTeam = async () => {
    // eslint-disable-next-line no-restricted-globals
    const result = confirm(
      'Подтвердить присутствие команды ' + name() + ' в полном составе.?'
    )
    if (result) {
      teamIsLocation(teamData.id)
      setbackgroundColor('#BADBAD33')
    }
  }
  const falseTeam = async () => {
    // eslint-disable-next-line no-restricted-globals
    const result = confirm('Удалить команду ' + name() + ' из турира.?')
    if (result) {
      teamNotLocation(teamData.id)
      setbackgroundColor('#EBC2AF33')
    }
  }
  const handleSubmitTeamEdit = async (teamDataNew) => {
    // setIsModalOpen(false)
    var isUpdate = false
    if (name() !== teamDataNew.teamName.trim()) isUpdate = true
    const spName1 = athleteData[0]?.fio ? athleteData[0].fio.trim() : ''
    if (spName1 !== teamDataNew.spName1) isUpdate = true
    const category1 = athleteData[0]?.sports_category
      ? athleteData[0].sports_category.trim()
      : ''
    if (category1 !== teamDataNew.category1) isUpdate = true
    const date1 =
      athleteData[0]?.dob && athleteData[0]?.dob != '0000-00-00'
        ? athleteData[0].dob.trim()
        : ''
    if (date1 !== teamDataNew.date1) isUpdate = true
    const spName2 = athleteData[1]?.fio ? athleteData[1].fio.trim() : ''
    if (spName2 !== teamDataNew.spName2) isUpdate = true
    const category2 = athleteData[1]?.sports_category
      ? athleteData[1].sports_category.trim()
      : ''
    if (category2 !== teamDataNew.category2) isUpdate = true
    const date2 =
      athleteData[1]?.dob && athleteData[1]?.dob != '0000-00-00'
        ? athleteData[1].dob.trim()
        : ''
    if (date2 !== teamDataNew.date2) isUpdate = true
    const spName3 = athleteData[2]?.fio ? athleteData[2].fio.trim() : ''
    if (spName3 !== teamDataNew.spName3) isUpdate = true
    const category3 = athleteData[2]?.sports_category
      ? athleteData[2].sports_category.trim()
      : ''
    if (category3 !== teamDataNew.category3) isUpdate = true
    const date3 =
      athleteData[3]?.dob && athleteData[3]?.dob != '0000-00-00'
        ? athleteData[3].dob.trim()
        : ''
    if (date3 !== teamDataNew.date3) isUpdate = true

    setEditData(teamDataNew)

    if (isUpdate) {
      const update_data = {
        do: 'updNewTeam',
        teamName: teamDataNew.teamName.trim(),
        teamid: teamData.id,
        id: id,
        spName1: teamDataNew.spName1.trim(),
        spName2: teamDataNew.spName2.trim(),
        spName3: teamDataNew.spName3.trim(),
        category1: teamDataNew.category1,
        category2: teamDataNew.category2,
        category3: teamDataNew.category3,
        date1: teamDataNew.date1,
        date2: teamDataNew.date2,
        date3: teamDataNew.date3,
        spid1: athleteData[0]?.id
          ? athleteData[0].id
          : teamDataNew.spName1.trim() === ''
            ? null
            : Date.now(),
        spid2: athleteData[1]?.id
          ? athleteData[1].id
          : teamDataNew.spName2.trim() === ''
            ? null
            : Date.now(),
        spid3: athleteData[2]?.id
          ? athleteData[2].id
          : teamDataNew.spName3.trim() === ''
            ? null
            : Date.now(),
      }

      const resultsU = await getData('teams', 'id', id)
      if (resultsU.length > 0) {
        const { key, value } = resultsU[0]

        const teamsArray = Object.values(value)

        var newAtletes = []
        for (let teams of teamsArray) {
          if (typeof teams === 'object' && teams !== null) {
            if (teams.team.id === teamData.id) {
              teams.team.team_name_ru = teamDataNew.teamName.trim()
              teams.team.preferred_name = 'ru'
              setteamData(teams.team)
              for (let i = 1; i < 4; i++) {
                var isok = false
                for (let athlet of teams.athlete) {
                  if (athlet.id === update_data['spid' + i]) {
                    if (update_data['spName' + i] !== '') {
                      athlet.fio = update_data['spName' + i]
                      athlet.dob = update_data['date' + i]
                      athlet.sports_category = update_data['category' + i]
                      newAtletes.push(athlet)
                      isok = true
                    }
                  }
                }
                if (!isok) {
                  if (update_data['spName' + i] !== '') {
                    const newAthlete = {
                      avatar: 'https://protocarp.ru/general_img/notuser.png',
                      dob: update_data['date' + i],
                      fio: update_data['spName' + i],
                      id: Date.now(),
                      identification: 'требуется проверка',
                      insurance: '',
                      insurance_expiry: null,
                      isBot: 1,
                      medical_clearance_expiry: null,
                      phone: '',
                      rusad_certificate: '',
                      rusad_expiry: null,
                      sports_category: update_data['category' + i],
                      sports_category_order_date: null,
                      sports_category_order_number: null,
                      requestKey: `${id}_dellUser_${new Date().getTime()}`,
                    }
                    newAtletes.push(newAthlete)
                  }
                }
              }
              teams.athlete = newAtletes
              setathleteData(teams.athlete)
            }
          }
        }
        // const requestKey = `${id}_dellUser_${new Date().getTime()}`
        // requestKey:  `${id}_dellUser_${new Date().getTime()}`,
        var obj = {}
        for (let teams of teamsArray) {
          if (typeof teams === 'object' && teams !== null)
            obj[teams.team.id] = teams
          else obj['id'] = teams
        }
        deleteData('teams', id)
        upsertDataTournaments('teams', obj)
      }

      try {
        await addRequestsData('requests', {
          url: 'teams/updNewTeam.php',
          ...update_data,
        })
      } catch (error) {}
    }
  }
  const editTeam = () => {
    setIsModalOpen(true)
  }

  if (teamData)
    return (
      <>
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={openBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid size={{ xs: 12, md: 12 }} onClick={openCupBut} style={{}}>
          <Item
            className="regateam"
            style={{
              backgroundColor: backgroundColor,
              padding: '18px',
            }}
          >
            <Stack direction="row" spacing={2} style={{ textAlign: 'left' }}>
              {teamData?.logo && (
                <img
                  alt="Logo Team"
                  variant="square"
                  src={'https://protocarp.ru/' + teamData?.logo}
                  style={{ objectFit: 'contain !important', height: '40px' }}
                />
              )}

              <div>
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{ marginBottom: '0px', lineHeight: '1.2' }}
                  className="color-text-black"
                >
                  {name()}
                </Typography>
                <Typography variant="caption" gutterBottom>
                  {teamData.name}
                </Typography>
              </div>
            </Stack>
            {athleteData.map((athlete, index) => (
              <Stack
                key={athlete.id}
                direction="row"
                spacing={2}
                style={{ textAlign: 'left', paddingTop: '20px' }}
              >
                <Avatar
                  alt={athlete.fio}
                  src={athlete.avatar}
                  sx={{ width: 45, height: 45 }}
                />

                <div>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ marginBottom: '0px' }}
                    className="color-text-black"
                  >
                    {athlete.fio}{' '}
                    {athlete.identification == 'идентифицирован' ? (
                      <StarIcon fontSize="small" style={{ fill: '#2a52be' }} />
                    ) : (
                      <></>
                    )}
                  </Typography>
                  <Typography
                    variant="caption"
                    gutterBottom
                    sx={{ display: 'block' }}
                  >
                    {dob_sport_categori(athlete.sports_category, athlete.dob)}
                  </Typography>
                </div>
                <Box sx={{ flexGrow: 1 }} />
                <div>
                  <IconButton
                    color="primary"
                    aria-label=" "
                    onClick={() => handleOpanSp(athlete)}
                  >
                    {athlete.isBot ? (
                      <SmartToyIcon style={{ fill: 'grey' }} />
                    ) : (
                      <ContactEmergencyIcon />
                    )}
                  </IconButton>
                </div>
              </Stack>
            ))}

            <Stack direction="row" spacing={2} style={{ paddingTop: '10px' }}>
              <Button
                variant="outlined"
                color="error"
                onClick={falseTeam}
                size="small"
                startIcon={<DeleteIcon />}
              >
                Удалить
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={editTeam}
                startIcon={<EditSharpIcon />}
              >
                Редактировать
              </Button>

              <Button
                variant="outlined"
                color="success"
                size="small"
                onClick={trueTeam}
                startIcon={<DoneOutlineSharpIcon />}
              >
                Подтвердить
              </Button>
            </Stack>
          </Item>
        </Grid>

        <Modal
          open={openModalSportsmen}
          onClose={handleCloseModalSportsmen}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Stack
              direction="row"
              spacing={2}
              style={{ textAlign: 'left', paddingTop: '10px', width: '100%' }}
            >
              <Avatar
                id="avataridsp"
                alt="s"
                src={modalAvatar}
                sx={{ width: 72, height: 72 }}
              />
              <div>
                <Typography variant="subtitle1">{modalName}</Typography>
                <Typography variant="subtitle1">
                  {modalIdentification}
                </Typography>
              </div>
            </Stack>
            <Typography
              variant="body2"
              id="modal-modal-description"
              sx={{ mt: 2 }}
            >
              {modalPhone}
            </Typography>
            <Typography variant="body2" id="modal-modal-description">
              {modalId}
            </Typography>
            <Typography variant="body2" id="modal-modal-description">
              {modalDob}
            </Typography>
            <Typography variant="body2" id="modal-modal-description">
              {modalSports_category}
            </Typography>
            <Typography variant="body2" id="modal-modal-description">
              {modalMedical}
            </Typography>
            <Typography variant="body2" id="modal-modal-description">
              {modalInsurance}
            </Typography>
            <Typography variant="body2" id="modal-modal-description">
              {modalRusad}
            </Typography>
          </Box>
        </Modal>
        <ModalAddTeam
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSubmit={handleSubmitTeamEdit}
          data={editData}
        />
      </>
    )
}

export default TeamRegistrationCard
